export enum WidgetNameList {
  selphid = 'selphid',
  selphi = 'selphi',
}

export const WidgetIdList: { [key in WidgetNameList]: string } = {
  [WidgetNameList.selphid]: '6152ccefc01f0c1eb6deedb8',
  [WidgetNameList.selphi]: '6152cce0c01f0c1eb6deedb7',
};
